import { useEffect } from "react";
import { motion, useReducedMotion, useSpring, useTransform } from "motion/react";
import { SPRING_VALUE } from "./motion";

interface AnimatedNumberProps {
  value: number;
  /**
   * Decimal places to render. Keep static after mount (changing it re-derives the
   * MotionValue). Recommended: 0 for counts/watts, 1 for temperatures/humidity.
   */
  precision?: number;
  className?: string;
}

/** Renders a number that springs to new values instead of jumping. */
export function AnimatedNumber({ value, precision = 0, className }: AnimatedNumberProps) {
  const reduced = useReducedMotion();
  const spring = useSpring(value, SPRING_VALUE);
  const display = useTransform(spring, (v) => v.toFixed(precision));

  useEffect(() => {
    if (reduced) spring.jump(value);
    else spring.set(value);
  }, [value, spring, reduced]);

  return <motion.span className={className}>{display}</motion.span>;
}
